module.exports = __webpack_public_path__ + "c647761c0c640a066a0a4348640e9fb8.pdf";